import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { ServiceEnqueteDeSatisfactionInstance } from "../../enqueteDeSatisfaction/service";
import { ExerciceDto } from "../../../dto/GenApi.iNotPaie.Dto/ExerciceDto";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";

export class ModalEnqueteSatisfactionOptions {
	public title = "Enquête de satisfaction";
	public message?: string = undefined;
	public callbackYes?: Function = undefined;

	public constructor(init?: Partial<ModalEnqueteSatisfactionOptions>) {
		(<any>Object).assign(this, init);
	}
}

@Component
export default class ModalEnqueteSatisfaction extends Vue {
	public title = "Enquête de satisfaction";
	public message?: string = undefined;
	public callbackYes?: Function = undefined;
	private lastExerciceClosed!: ExerciceDto;

	public note = 0;
	public commentaire = "";

	public init(options: ModalEnqueteSatisfactionOptions): void {
		this.message = options.message;
		this.title = options.title;
		this.callbackYes = options.callbackYes;
		this.$forceUpdate();
		$("#modalEnqueteSatisfaction").modal("show");
	}

	public valider(): void {
		this.lastExerciceClosed = ServiceEnqueteDeSatisfactionInstance.getLastExerciceClosed();
		this.update();
		this.closeModal();
		if (this.callbackYes != undefined) {
			this.callbackYes();
		}
	}

	private update(): void {
		this.lastExerciceClosed.Note = this.note;
		this.lastExerciceClosed.Commentaire = this.commentaire;
		ServicesFactoryInstance.ExercicesService.updateSatisfaction(this.lastExerciceClosed, () => {
			NotificationServiceInstance.SendSuccess("La note a bien été prise en compte.");
		});
	}

	private closeModal(): void {
		$("#modalEnqueteSatisfaction").modal("hide");
	}

	public annuler(): void {
		this.closeModal();
	}
}




// WEBPACK FOOTER //
// ./src/components/modalComponents/modalEnqueteSatisfaction/modalEnqueteSatisfaction.ts